import { Dispatch, SetStateAction, useState } from 'react';
import { editCoctail } from '../../../store/coctailsSlice';
import { useAppDispatch } from '../../../store/hooks';
import { ICoctail, TActions } from '../../../types';
import { message } from 'antd';
import { Upload } from '../../../components';

const AddingVideo = ({
  action,
  coctail,
  setCoctail,
  onToggleDisabled,
}: {
  coctail?: ICoctail;
  action: TActions;
  setCoctail: Dispatch<SetStateAction<ICoctail>>;
  onToggleDisabled?: (value: boolean) => void;
}) => {
  const dispatch = useAppDispatch();

  const onUpdateVideoCoctail = async (videoName: string | null) => {
    onToggleDisabled?.(true);
    setCoctail(prev => ({
      ...prev,
      eng: { ...prev.eng, media: { ...prev?.eng?.media, videoName } },
    }));
    if (action === 'edit') {
      await dispatch(
        editCoctail({
          coctail: {
            ...coctail,
            eng: { ...coctail.eng, media: { ...coctail?.eng?.media, videoName } },
          },
          id: coctail._id,
        }),
      );
      message.success('Video updated successfully!');
      onToggleDisabled?.(false);
    }
  };

  return (
    <div style={{ maxWidth: '500px' }}>
      <Upload
        type="video"
        withDeleteButton
        value={coctail?.eng?.media?.videoName || null}
        setValue={onUpdateVideoCoctail}
        acceptFile={{
          'video/mp4': ['.mp4', '.MP4'],
        }}
        onToggleDisabled={onToggleDisabled}
      />
    </div>
  );
};

export default AddingVideo;
